import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n/LanguageContext";
import { legalPagesByLang } from "../i18n/legal";
import { LogoMark } from "./Logo";
import { SocialRow } from "./Socials";

export const Footer = () => {
  const { t, lang } = useI18n();
  const year = new Date().getFullYear();
  const legalPages = legalPagesByLang(lang);
  const legalLinks = [
    { key: "mentions", page: legalPages.mentions },
    { key: "privacy", page: legalPages.privacy },
    { key: "terms", page: legalPages.terms },
  ];

  return (
    <footer className="border-t border-white/10 bg-[#0F0F11]" data-testid="site-footer">
      <div className="px-5 md:px-10 lg:px-16 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <LogoMark size={48} />
              <div>
                <div className="font-display text-3xl font-black tracking-tighter text-white">
                  CT<span className="text-flame">3</span>F
                </div>
                <div className="label-tech text-white/40 mt-1">LU · FR · BE</div>
              </div>
            </div>
            <p className="label-tech mt-5 text-white/40">{t.footer.tag}</p>
            <p className="mt-6 text-white/65 max-w-md leading-relaxed">{t.footer.desc}</p>
            <div className="mt-6 flex items-center gap-2">
              {["LU", "FR", "BE"].map((c) => (
                <span
                  key={c}
                  className="label-tech border border-white/15 px-2 py-1 text-white/75"
                >
                  [ {c} ]
                </span>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="label-tech text-white/40 mb-4">{t.footer.navTitle}</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-white/80 hover:text-ct3f-amber transition-colors">
                  {t.nav.home}
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/80 hover:text-ct3f-amber transition-colors">
                  {t.nav.services}
                </Link>
              </li>
              <li>
                <Link to="/calculateurs" className="text-white/80 hover:text-ct3f-amber transition-colors">
                  {t.nav.calculators}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/80 hover:text-ct3f-amber transition-colors">
                  {t.nav.contact}
                </Link>
              </li>
            </ul>

            <h4 className="label-tech text-white/40 mt-8 mb-4">{t.footer.socialTitle}</h4>
            <SocialRow variant="muted" testidPrefix="footer-social" />
          </div>

          <div className="md:col-span-4">
            <h4 className="label-tech text-white/40 mb-4">CONTACT</h4>
            <ul className="space-y-2 text-white/80">
              <li>
                <a href="mailto:ctluxembourg@outlook.com" className="hover:text-ct3f-amber transition-colors" data-testid="footer-email">
                  ctluxembourg@outlook.com
                </a>
              </li>
              <li>
                <a href="mailto:info@ct3f.com" className="hover:text-ct3f-amber transition-colors" data-testid="footer-email-alt">
                  info@ct3f.com
                </a>
              </li>
              <li>
                <a href="tel:+352621739411" className="hover:text-ct3f-amber transition-colors" data-testid="footer-phone-lu">
                  +352 621 739 411 <span className="label-tech text-white/40 ml-2">LU</span>
                </a>
              </li>
              <li>
                <a href="tel:+32470456536" className="hover:text-ct3f-amber transition-colors" data-testid="footer-phone-be">
                  +32 470 45 65 36 <span className="label-tech text-white/40 ml-2">BE</span>
                </a>
              </li>
              <li className="text-white/55 text-sm">Lun — Ven · 08:30 — 17:00</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="label-tech text-white/40">
            © {year} CT3F · RAINALDI Fabrizio · {t.footer.copy}
          </p>
          <ul className="flex flex-wrap gap-6">
            {legalLinks.map(({ key, page }) => (
              <li key={key}>
                <Link
                  to={`/${page.slug}`}
                  data-testid={`footer-legal-${key}`}
                  className="label-tech text-white/50 hover:text-white transition-colors"
                >
                  {page.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
